import { render, staticRenderFns } from "./EditModalLayout.vue?vue&type=template&id=2abe4228&"
import script from "./EditModalLayout.vue?vue&type=script&lang=ts&"
export * from "./EditModalLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports